<template>
    <div id="graph-reposicao-estoque" class="border-gray-400 border bg-white rounded px-6 py-4 shadow-lg h-full">
        <div v-if="loading" class="loading"></div>
        <div v-else class="graph-content">
            <h2 class="text-gray-900 font-bold text-xl mb-4">Atualmente encontra dificuldade para reposição de estoque ou aquisição de insumo para sua atividade?</h2>
            <div class="empty" v-if="!(statistics && statistics.length !== 0)"></div>
            <div class="canvas-container" style="position: relative; min-height: 350px; height: auto">
                <canvas class="graph-reposicao-estoque-canvas my-5"></canvas>
            </div>
        </div>
    </div>
</template>

<script>
    import Chart from 'chart.js'

    let chart;

    window.addEventListener('resize', function () { chart.resize() })

    export default {
        props: {
            statistics: {
                type: Array,
                required: true
            }
        },
        watch: {
            statistics(newVal) {
                const labels = newVal?.map(statistic => statistic.label)
                const chartData = newVal?.map(statistic => statistic.value)
                this.renderChart(chartData, labels)
            }
        },
        mounted() {
            const labels = this.statistics?.map(statistic => statistic.label)
            const chartData = this.statistics?.map(statistic => statistic.value)
            this.renderChart(chartData, labels)
        },
        data() {
            return {
                colors: ['#269ef7', '#26e7a7', '#ffba58', '#E76F51', '#8AB17D', '#5DB7DE', '#264653', '#175676', '#697A21', '#D62839', '#7D5BA6', '#55D6BE'],
                loading: false
            }
        },
        methods: {
            renderChart(data, labels) {
                const ctx = document.getElementsByClassName('graph-reposicao-estoque-canvas')[0]
                this.chart = new Chart(ctx, {
                    type: 'doughnut',
                    data: {
                        labels,
                        datasets: [{
                            data,
                            backgroundColor: this.colors
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            position: 'bottom'
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    //get the concerned dataset
                                    const dataset = data.datasets[tooltipItem.datasetIndex];
                                    //calculate the total of this data set
                                    const total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                                        return previousValue + currentValue;
                                    });
                                    //get the current items value
                                    const currentValue = dataset.data[tooltipItem.index];
                                    //calculate the precentage based on the total and current item, also this does a rough rounding to give a whole number
                                    const percentage = Math.floor(((currentValue/total) * 100)+0.5);

                                    return percentage + "%";
                                }
                            }
                        }
                    }
                })
                chart = this.chart
            }
        }
    }
</script>